import React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { useBexApi } from '@shared-ui/bex-api-context';
import useNavigationParams from '../../hooks/useNavigationParams';
import {
  RelationshipsDataFragment,
  useRelationshipsQuery,
  RelatedElementFragment,
  RelatedSectionFragment,
  RelatedTitleFragment,
} from '../../graphql/__generated__/types';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkLink } from 'uitk-react-link';
import { UitkSpacing } from 'uitk-react-spacing';

const RelatedSection = () => {
  const { hubId, documentId } = useNavigationParams();
  const { context } = useBexApi();
  const { data, loading, error } = useRelationshipsQuery({ variables: { context, hubId, documentId } });

  if (error || loading || !data) {
    return null;
  }

  const relationships = data.documentation.relationships as RelationshipsDataFragment;
  const related: RelatedSectionFragment = relationships.related;
  const relatedTitle: RelatedTitleFragment = related?.title;
  const relatedElements: Array<RelatedElementFragment> | undefined = related?.elements;

  if (!relatedElements || relatedElements.length === 0) {
    return <></>;
  }

  return (
    <div>
      <UitkLayoutFlex space="three" direction="column">
        <UitkLayoutFlexItem>
          <UitkHeading tag="h2">
            <UitkText theme="default" inline size={400}>
              {relatedTitle.text}
            </UitkText>
          </UitkHeading>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <UitkSpacing margin={{ inlinestart: 'one' }}>
            <div>
              <UitkLayoutFlex space="two" direction="column">
                {relatedElements.map((element) => (
                  <UitkLayoutFlexItem key={`${element.title.text}${element.subtitle?.text}`}>
                    <UitkLink>
                      <a href={element.url.resource.value}>
                        <div>
                          <UitkHeading tag="h3">
                            <UitkText theme="default" inline>
                              {element.title.text}
                            </UitkText>
                          </UitkHeading>
                        </div>
                      </a>
                    </UitkLink>
                  </UitkLayoutFlexItem>
                ))}
              </UitkLayoutFlex>
            </div>
          </UitkSpacing>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </div>
  );
};

export default RelatedSection;
